import { GROUPS } from './GROUPS';
import { ROLES_GROUPS } from './ROLES_GROUPS';
import { ROLES } from './ROLES';

export enum OrderActionCrmTask {
    OC = 'OC',
    PRODUCCION = 'Producción',
    ENTREGA = 'Entrega',
    FACTURACION = 'Facturación',
    COBRANZA = 'Cobranza'
}

export interface OrderAction {
    id: number;
    name: string;
    button: string | null;
    /** Permite que el ejecutivo salte este paso del flujo. */
    skipStepButton: boolean;
    enabledMessage: string;
    disbledMessage: string;
    defaultPermissions: string[];
    defaultNotifications: string[];
    crmTask?: OrderActionCrmTask;
}

export const PREMIUM_ORDER_ACTIONS: OrderAction[] = [
    {
        id: 1,
        name: 'Sample Request',
        button: 'Define Samples',
        skipStepButton: true,
        enabledMessage:
            'Quote authorized. Please specify which products require samples',
        disbledMessage: 'Quote authorized. Sample definition pending',
        defaultPermissions: [...ROLES_GROUPS.MKT_GROUP],
        defaultNotifications: [
            GROUPS.MANAGEMENT,
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.CONTRACTOR,
            GROUPS.PROVIDER
        ]
    },
    {
        id: 2,
        name: 'Upload Delivery Receipts',
        button: 'Upload Delivery Evidence',
        skipStepButton: false,
        enabledMessage: 'Please upload delivery documents and shipping guides',
        disbledMessage:
            'Purchase and samples approved. Awaiting delivery by suppliers',
        defaultPermissions: [
            ROLES.ADMINISTRATOR,
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD,
            ROLES.PROVEEDOR
        ],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.PROVIDER
        ],
        crmTask: OrderActionCrmTask.ENTREGA
    },
    {
        id: 3,
        name: 'GR and Payment Date',
        button: 'No Changes',
        skipStepButton: false,
        enabledMessage: 'Product delivered. Please upload GR tables',
        disbledMessage: 'Product delivered. Awaiting GR code',
        defaultPermissions: [...ROLES_GROUPS.SD_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.PROVIDER
        ]
    },
    {
        id: 4,
        name: 'Review Samples',
        button: 'Review Samples',
        skipStepButton: true,
        enabledMessage:
            'Samples uploaded by suppliers. To proceed with the workflow, please approve the samples',
        disbledMessage: 'Awaiting sample approval by the contractor',
        defaultPermissions: [...ROLES_GROUPS.MKT_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.CONTRACTOR
        ]
    },
    {
        id: 5,
        name: 'Upload Coupa Purchase Order',
        button: 'Upload Coupa PO',
        skipStepButton: false,
        enabledMessage:
            'Quote authorized and sent. Please upload your Coupa purchase order',
        disbledMessage:
            'Quote authorized and sent. Awaiting Coupa purchase order',
        defaultPermissions: [...ROLES_GROUPS.SD_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.CONTRACTOR
        ],
        crmTask: OrderActionCrmTask.OC
    },
    {
        id: 6,
        name: 'Factoring Request',
        button: 'Request Factoring',
        skipStepButton: false,
        enabledMessage: 'Suppliers with payment date. Awaiting payment order',
        disbledMessage: 'Suppliers with payment date. Awaiting payment order',
        defaultPermissions: [...ROLES_GROUPS.PROVIDER_GROUP],
        defaultNotifications: [GROUPS.ADMIN, GROUPS.AGENTS, GROUPS.PROVIDER]
    },
    {
        id: 7,
        name: 'Checkout to Coupa',
        button: 'Checkout to Coupa',
        skipStepButton: true,
        enabledMessage: 'Quote ready. You can proceed with checkout to Coupa',
        disbledMessage: 'Quote ready. Awaiting checkout to Coupa',
        defaultPermissions: [...ROLES_GROUPS.MKT_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.CONTRACTOR,
            GROUPS.COUPA
        ]
    },
    {
        id: 8,
        name: 'Validate Invoices',
        button: 'Validate Invoices',
        skipStepButton: false,
        enabledMessage: 'Please validate the project invoices in the CRM',
        disbledMessage: 'Awaiting invoice validation',
        defaultPermissions: [],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.ADMINISTRATION
        ],
        crmTask: OrderActionCrmTask.FACTURACION
    },
    {
        id: 9,
        name: 'Upload GR',
        button: 'Upload GR',
        skipStepButton: false,
        enabledMessage: 'Product delivered. Please upload GR tables',
        disbledMessage: 'Product delivered. Awaiting GR code',
        defaultPermissions: [...ROLES_GROUPS.SD_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.PROVIDER
        ]
    },
    {
        id: 10,
        name: 'Validate Receipt Upload',
        button: 'I have uploaded all receipts',
        skipStepButton: false,
        enabledMessage:
            'Please confirm that you have uploaded all delivery receipts',
        disbledMessage:
            'Purchase and samples approved. Awaiting delivery by suppliers',
        defaultPermissions: [
            ROLES.ADMINISTRATOR,
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD,
            ROLES.PROVEEDOR
        ],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.PROVIDER
        ]
    },
    {
        id: 11,
        name: 'Purchasing Authorization',
        button: 'Authorize Quote',
        skipStepButton: true,
        enabledMessage: 'Quote pending authorization by purchasing',
        disbledMessage: 'Quote pending authorization by purchasing',
        defaultPermissions: [ROLES.COMPRAS_SR],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.CONTRACTOR
        ]
    },
    {
        id: 12,
        name: 'Validate Delivery',
        button: 'Validate Delivery',
        skipStepButton: false,
        enabledMessage:
            'Please confirm that product delivery has been completed',
        disbledMessage: 'Awaiting product delivery validation',
        defaultPermissions: [...ROLES_GROUPS.SD_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.CONTRACTOR,
            GROUPS.PROVIDER
        ]
    },
    {
        id: 13,
        name: 'Complete Purchase',
        button: 'Complete',
        skipStepButton: false,
        enabledMessage:
            'To complete the purchase, please upload payment receipts in the CRM',
        disbledMessage: 'Awaiting payment receipt upload',
        defaultPermissions: [],
        defaultNotifications: [GROUPS.ADMIN, GROUPS.OPERATIVO, GROUPS.AGENTS],
        crmTask: OrderActionCrmTask.COBRANZA
    },
    {
        id: 14,
        name: 'Administration Approval',
        button: 'Notify Final Version',
        skipStepButton: false,
        enabledMessage: '',
        disbledMessage: '',
        defaultPermissions: [],
        defaultNotifications: [GROUPS.ADMIN, GROUPS.AGENTS]
    },
    {
        id: 15,
        name: 'Upload Invoice',
        button: 'Upload Invoice',
        skipStepButton: false,
        enabledMessage: 'Please upload invoices in the CRM',
        disbledMessage: 'Awaiting invoices',
        defaultPermissions: [],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.ADMINISTRATION
        ]
    },
    {
        id: 16,
        name: 'Process Completed',
        button: null,
        skipStepButton: false,
        enabledMessage: 'Process completed',
        disbledMessage: 'Process completed',
        defaultPermissions: [],
        defaultNotifications: [
            GROUPS.MANAGEMENT,
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.CONTRACTOR,
            GROUPS.PROVIDER
        ]
    },
    {
        id: 17,
        name: 'Pre-quote Supplier Changes',
        button: 'No Changes',
        skipStepButton: false,
        enabledMessage: '',
        disbledMessage: '',
        defaultPermissions: [],
        defaultNotifications: [GROUPS.ADMIN, GROUPS.AGENTS]
    },
    {
        id: 18,
        name: 'Marketing Confirmation',
        button: 'Confirm Pre-quote',
        skipStepButton: false,
        enabledMessage: '',
        disbledMessage: '',
        defaultPermissions: [],
        defaultNotifications: [GROUPS.ADMIN, GROUPS.AGENTS]
    },
    {
        id: 19,
        name: 'Supplier Sample Upload',
        button: 'Upload Samples',
        skipStepButton: false,
        enabledMessage:
            'If product samples were requested, please upload sample approval documents',
        disbledMessage: 'Waiting for all suppliers to upload their samples',
        defaultPermissions: [
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD,
            ROLES.PROVEEDOR
        ],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.PROVIDER,
            GROUPS.CONTRACTOR
        ]
    },
    {
        id: 20,
        name: 'Request Quality',
        button: 'No Changes',
        skipStepButton: false,
        enabledMessage: '',
        disbledMessage: '',
        defaultPermissions: [],
        defaultNotifications: [GROUPS.ADMIN, GROUPS.AGENTS]
    },
    {
        id: 21,
        name: 'Quality Documentation',
        button: 'Upload Quality Documents to SharePoint',
        skipStepButton: false,
        enabledMessage:
            'Once quality forms are completed, they must be sent to the quality department',
        disbledMessage: 'Quality process in progress',
        defaultPermissions: [
            ROLES.CALIDAD,
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD,
            ROLES.ADMINISTRATOR
        ],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.QUALITY,
            GROUPS.AGENTS
        ]
    },
    {
        id: 22,
        name: 'Quality Validation - Purchasing',
        button: 'Review Quality Documents',
        skipStepButton: false,
        enabledMessage: 'Please validate product quality information',
        disbledMessage: 'Quality user must validate the information',
        defaultPermissions: [ROLES.CALIDAD],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.QUALITY,
            GROUPS.AGENTS
        ]
    },
    {
        id: 23,
        name: 'Upload Quality Files',
        button: 'Upload Quality Documents',
        skipStepButton: false,
        enabledMessage:
            'You must send approved and signed quality documents to Brand Factory and upload them to the portal',
        disbledMessage: 'Waiting for quality process to be completed',
        defaultPermissions: [
            ROLES.CALIDAD,
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD,
            ROLES.ADMINISTRATOR
        ],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.QUALITY,
            GROUPS.AGENTS
        ]
    },
    {
        id: 24,
        name: 'Purchasing Authorization 2',
        button: 'Authorize Quote',
        skipStepButton: true,
        enabledMessage: 'Quote pending authorization by purchasing',
        disbledMessage: 'Quote pending authorization by purchasing',
        defaultPermissions: [ROLES.COMPRAS_SR],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.CONTRACTOR
        ]
    },
    {
        id: 25,
        name: 'Product Evaluation',
        button: 'Evaluate',
        skipStepButton: true,
        enabledMessage:
            'Purchase delivered. Please help us evaluate your shopping experience',
        disbledMessage: 'Awaiting purchase evaluation',
        defaultPermissions: [ROLES.COMPRAS, ROLES.COMPRAS_SR],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.CONTRACTOR
        ]
    },
    {
        id: 26,
        name: 'Checkout Conekta',
        button: 'payment-actions.proceedToPayment',
        skipStepButton: true,
        enabledMessage: '',
        disbledMessage: '',
        defaultPermissions: [ROLES.COMPRAS, ROLES.COMPRAS_SR],
        defaultNotifications: [GROUPS.ADMIN, GROUPS.AGENTS]
    },
    {
        id: 27,
        name: 'Upload Conekta Purchase Order',
        button: 'Upload Conekta PO',
        skipStepButton: false,
        enabledMessage: '',
        disbledMessage: '',
        defaultPermissions: [],
        defaultNotifications: [GROUPS.ADMIN, GROUPS.AGENTS],
        crmTask: OrderActionCrmTask.OC
    },
    {
        id: 28,
        name: 'Pay with Clip',
        button: 'payment-actions.proceedToPayment',
        skipStepButton: true,
        enabledMessage: 'payment-actions.redirectWarning',
        disbledMessage: 'Awaiting payment with Clip (Credit or Debit Card)',
        defaultPermissions: [ROLES.COMPRAS, ROLES.COMPRAS_SR],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.CONTRACTOR
        ]
    },
    {
        id: 29,
        name: 'Validate Clip Payment',
        button: 'Validate Clip Payment',
        skipStepButton: false,
        enabledMessage:
            'Purchase paid. Please verify that the payment is reflected in Clip (Credit or Debit Card) before validating',
        disbledMessage:
            'Payment completed. Validation in progress. If you require an invoice, please upload your tax situation certificate.',
        defaultPermissions: [
            ROLES.ADMINISTRATOR,
            ROLES.OPERATIVO,
            ROLES.PROVEEDOR_SD
        ],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.ADMINISTRATION,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.CONTRACTOR
        ],
        crmTask: OrderActionCrmTask.OC
    },
    {
        id: 30,
        name: 'Upload Purchase Order',
        button: 'Upload Purchase Order',
        skipStepButton: false,
        enabledMessage:
            'Quote authorized. Please upload the purchase order or project request evidence',
        disbledMessage: 'Quote authorized and sent. Awaiting purchase order',
        defaultPermissions: [...ROLES_GROUPS.SD_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.CONTRACTOR
        ],
        crmTask: OrderActionCrmTask.OC
    },
    {
        id: 31,
        name: 'Upload Bank Transfer Receipt',
        button: 'Upload Bank Transfer Receipt',
        skipStepButton: true,
        enabledMessage:
            'Please upload the bank transfer receipt to CLABE 1121 8000 0035 056332, Beneficiary: SOURCE DATA PURCHASING SA DE CV',
        disbledMessage:
            'Quote authorized and sent. Awaiting bank transfer receipt',
        defaultPermissions: [
            ...ROLES_GROUPS.MKT_GROUP,
            ...ROLES_GROUPS.SD_GROUP
        ],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.CONTRACTOR
        ]
    },
    {
        id: 32,
        name: 'Validate Bank Transfer Receipt',
        button: 'Validate Bank Transfer Receipt',
        skipStepButton: false,
        enabledMessage:
            'Please validate the receipt to initiate the logistics flow',
        disbledMessage: 'Awaiting receipt validation by Brand Factory',
        defaultPermissions: [...ROLES_GROUPS.SD_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.ADMINISTRATION,
            GROUPS.CONTRACTOR
        ],
        crmTask: OrderActionCrmTask.OC
    },
    {
        id: 33,
        name: 'Pay with EtPay',
        button: 'payment-actions.proceedToPayment',
        skipStepButton: true,
        enabledMessage: 'payment-actions.redirectWarning',
        disbledMessage: 'Awaiting payment with EtPay (Bank Transfer)',
        defaultPermissions: [...ROLES_GROUPS.MKT_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.CONTRACTOR
        ]
    },
    {
        id: 34,
        name: 'Validate EtPay Payment',
        button: 'Validate EtPay Payment',
        skipStepButton: false,
        enabledMessage:
            'Purchase paid. Please verify that the payment is reflected in EtPay (Bank Transfer) before validating',
        disbledMessage:
            'Payment completed. Validation in progress. If you require an invoice, please upload your tax situation certificate.',
        defaultPermissions: [...ROLES_GROUPS.SD_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.ADMINISTRATION,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.CONTRACTOR
        ],
        crmTask: OrderActionCrmTask.OC
    },
    {
        id: 35,
        name: 'Pay with Stripe',
        button: 'payment-actions.proceedToPayment',
        skipStepButton: true,
        enabledMessage: 'payment-actions.redirectWarning',
        disbledMessage: 'Awaiting payment with Stripe (Card)',
        defaultPermissions: [...ROLES_GROUPS.MKT_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.AGENTS,
            GROUPS.CONTRACTOR
        ]
    },
    {
        id: 36,
        name: 'Validate Stripe Payment',
        button: 'Validate Stripe Payment',
        skipStepButton: false,
        enabledMessage:
            'Purchase paid. Please verify that the payment is reflected in Stripe before validating',
        disbledMessage:
            'Payment completed. Validation in progress. If you require an invoice, please upload your tax situation certificate.',
        defaultPermissions: [...ROLES_GROUPS.SD_GROUP],
        defaultNotifications: [
            GROUPS.ADMIN,
            GROUPS.OPERATIVO,
            GROUPS.ADMINISTRATION,
            GROUPS.AGENTS,
            GROUPS.MARKETING,
            GROUPS.CONTRACTOR
        ],
        crmTask: OrderActionCrmTask.OC
    }
];

/**
 * IDs de subproceso (`OrderSubprocessStructure.action`) en los que la UI del pedido
 * premium muestra controles de facturación en la barra de acciones (factura, CSF,
 * datos de transferencia, etc.).
 *
 * No incluye **30** (Carga OC): ese paso no activa ese bloque de facturación en esa barra.
 * Tampoco incluye **35** / **36** (Stripe); si deben comportarse como Clip/EtPay, añadir sus ids aquí.
 *
 * @see PREMIUM_ORDER_ACTIONS — entradas con id 28, 29, 31, 32, 33, 34 (y 30 como contraste excluido)
 */
export const PREMIUM_ORDER_BILLING_UI_ACTION_IDS: ReadonlyArray<number> = [
    28,
    29,
    31,
    32,
    33,
    34
];

/** Subproceso "Completar orden" (comprobantes de pago finales). */
export const PREMIUM_ORDER_ACTION_COMPLETAR_ORDEN_ID = 13;

/** Subproceso "Proceso finalizado" — sin reasignar ni eliminar desde la barra de acciones. */
export const PREMIUM_ORDER_ACTION_PROCESO_FINALIZADO_ID = 16;
